<template>
    <v-row style="width: 670px; height: 200px; background-color: #140542; color: white;" class="px-0 py-1  ml-1" align="center" justify="center">
        <v-col cols="2" class="px-0 mx-0 custom-teal-text font-weight-bold" style="font-size: 1.5rem;">
            {{ type }}
        </v-col>
        <v-col cols="3" align="center" class="px-1 py-0 my-0">
            <v-avatar style="border-radius: 10px;" size="80" color="white">
                <img
                    :src="`${assetsUrl}/${match.team1?.logo}`"
                    height="80px"
                    width="auto"
                    contain
                >
            </v-avatar>
            <div class="text-h5 font-weight-bold" :style="`width: 100%; border-top: 8px solid ${match.team1.color}; font-size: 1.5rem;`">{{ team1Stat }}</div>
        </v-col>
        <v-col cols="4" class="pr-0 py-0 pb-3">
            <doughnut-chart
                :chart-data="{
                    datasets: [
                        {
                            backgroundColor: [match.team2.color, match.team1.color],
                            data: [team2Stat, team1Stat]
                        }
                    ]
                }"
                :type="type"
            />
        </v-col>
        <v-col cols="3" align="center" class="px-1 py-0 my-0">
            <v-avatar style="border-radius: 10px;" size="80" color="white">
                <img
                    :src="`${assetsUrl}/${match.team2?.logo}`"
                    height="80px"
                    width="auto"
                    contain
                >
            </v-avatar>
            <div class="font-weight-bold" :style="`width: 100%; border-top: 8px solid ${match.team2.color}; font-size: 1.5rem;`">{{ team2Stat }}</div>
        </v-col>
    </v-row>
</template>

<script>
    import DoughnutChart from '@/components/Doughnut.vue'

    export default {
        components: {
            DoughnutChart
        },
        props: {
            type: {
                type: String,
                default: null
            },
            match: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com',
                team1Stat: 0,
                team2Stat: 0
            }
        },
        watch: {
            match: {
                handler() {
                    this.team1Stat = this.getTeam1Stat()
                    this.team2Stat = this.getTeam2Stat()
                    this.$forceUpdate()
                    // this.$emit('updateEvents')
                },
                deep: true,
                immediate: true
            }
        },
        created() {
            this.$emit('updateEvents')
        },
        updated() {
            this.$emit('updateEvents')
        },
        methods: {
            getTeam1Stat() {
                if (this.type === 'T.R.') {
                    return (this.match.team1.offensiveRebounds + this.match.team1.defensiveRebounds)
                } else if (this.type === 'AST') {
                    return this.match.team1.assists
                } else if (this.type === 'STL') {
                    return this.match.team1.steals
                } else if (this.type === 'BLK') {
                    return this.match.team1.blockedShots
                } else if (this.type === 'TO') {
                    return this.match.team1.turnovers
                } else if (this.type === '1P') {
                    return ((this.match.team1.freeThrowsMade / this.match.team1.freeThrowAttempts) * 100).toFixed(1)
                } else if (this.type === '2P') {
                    return ((this.match.team1.twoPointsMade / this.match.team1.twoPointAttempts) * 100).toFixed(1)
                } else if (this.type === '3P') {
                    return ((this.match.team1.threePointsMade / this.match.team1.threePointAttempts) * 100).toFixed(1)
                }
            },
            getTeam2Stat() {
                if (this.type === 'T.R.') {
                    return (this.match.team2.offensiveRebounds + this.match.team2.defensiveRebounds)
                } else if (this.type === 'AST') {
                    return this.match.team2.assists
                } else if (this.type === 'STL') {
                    return this.match.team2.steals
                } else if (this.type === 'BLK') {
                    return this.match.team2.blockedShots
                } else if (this.type === 'TO') {
                    return this.match.team2.turnovers
                } else if (this.type === '1P') {
                    return ((this.match.team2.freeThrowsMade / this.match.team2.freeThrowAttempts) * 100).toFixed(1)
                } else if (this.type === '2P') {
                    return ((this.match.team2.twoPointsMade / this.match.team2.twoPointAttempts) * 100).toFixed(1)
                } else if (this.type === '3P') {
                    return ((this.match.team2.threePointsMade / this.match.team2.threePointAttempts) * 100).toFixed(1)
                }
            }
        }
    }
</script>

<style>
    .v-progress-circular__info {
        display: block;
    }
</style>
